<!-- eslint-disable max-len -->
<template>
  <v-main>
    <v-container fluid class="mt-16">
      <v-card
          :flat="$vuetify.theme.dark"
          :outlined="$vuetify.theme.dark"
          class="mx-auto"
          rounded="lg"
          max-width="900px"
      >
        <v-dialog
          v-model="prospectLoginErrorDialog"
          max-width="300"
        >
          <v-card light>
            <v-card-title class="text-h5">
              Error
            </v-card-title>
            <v-card-text>{{ errorResponse }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="prospectLoginErrorDialog = false"
              >Ok</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row no-gutters>
          <v-col cols="6" class="d-none d-sm-block">
            <div style="display: flex; width: 100%; height: 100%;">
              <img
                src="@/assets/mark_bgs/Landrum-HR-Interior-7.png"
                style="border-radius: 8px 0 0 8px; min-width: 100%;"
                alt=""
              >
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <v-row class="text-center">
              <v-col cols="12">
                <v-img
                  :src="chooseLogo2"
                  max-width="80%"
                  class="mx-auto mt-16"
                ></v-img>
              </v-col>
              <v-col cols="12">
                <div
                  style="font-family: Fira+Sans !important;"
                  class="text-h4"
                  >Log in to continue</div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  label="Email"
                  class="mx-8"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="password"
                  type="password"
                  label="Password"
                  class="mx-8"
                  @keyup.enter="prospectLogin"
                ></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-checkbox
                  v-model="remember"
                  label="Remember Me"
                  hide-details
                  class="mt-0 ml-8 text-body-2"
                ></v-checkbox>
              </v-col>
              <v-col sm="6">
                <a href="forgotPassword" class="text-body-2">Forgot Password?</a>
              </v-col>
              <v-col cols="12">
                <div class="mx-8">
                  <v-btn
                    large
                    outlined
                    class="my-5 text-capitalize"
                    block
                    @click="prospectLogin"
                    :loading="btnLoading"
                  >Log In</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <div class="d-flex justify-center pa-2">
      <v-switch
        v-model="toggleTheme"
        inset
      >
        <template v-slot:label>
          <v-icon>mdi-theme-light-dark</v-icon>
        </template>
      </v-switch>
    </div>
  </v-main>
</template>

<script>
export default {
  name: 'ProspectLogin',
  data: () => ({
    local: null,
    session: null,
  }),
  mounted() {
    this.token = localStorage.getItem('token');
    this.session = sessionStorage.getItem('token');
    if (this.token || this.session) {
      this.$store.dispatch('validateToken');
    }
  },
  computed: {
    toggleTheme: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(value) {
        this.$vuetify.theme.dark = value;
        localStorage.setItem('darkMode', value);
        if (this.$vuetify.theme.dark) {
          // eslint-disable-next-line no-underscore-dangle
          window._paq.push(['trackEvent', 'Theme', 'DarkMode', 'Turned on dark mode']);
        } else {
          // eslint-disable-next-line no-underscore-dangle
          window._paq.push(['trackEvent', 'Theme', 'DarkMode', 'Turned off dark mode']);
        }
      },
    },
    chooseLogo() {
      if (this.$vuetify.theme.dark) {
        // return 'landrum-logo-darkv2.png';
        return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
      }

      // return 'landrum-logo-light.png';
      return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
    },
    chooseLogo2() {
      if (this.$vuetify.theme.dark) {
        return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
      }

      return 'https://assets.landrumhr.com/logos/Solutions-Color.png';
    },
    btnLoading() {
      return this.$store.state.prospectLoginCreds.loading;
    },
    email: {
      get() {
        return this.$store.state.prospectLoginCreds.email;
      },
      set(value) {
        this.$store.commit('updateProspectLoginEmail', value);
      },
    },
    password: {
      get() {
        return this.$store.state.prospectLoginCreds.password;
      },
      set(value) {
        this.$store.commit('updateProspectLoginPassword', value);
      },
    },
    remember: {
      get() {
        return this.$store.state.prospectLoginCreds.remember;
      },
      set(value) {
        this.$store.commit('updateProspectLoginRemember', value);
      },
    },
    prospectLoginErrorDialog: {
      get() {
        return this.$store.state.prospectLoginErrorDialog;
      },
      set(value) {
        this.$store.commit('updateProspectLoginErrorDialog', value);
      },
    },
    errorResponse() {
      return this.$store.state.prospectLoginErrorResponse;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
  },
  methods: {
    prospectLogin() {
      this.$store.commit('updateProspectLoginLoading', true);
      this.$store.dispatch('loginToProspect').then(() => {
        if (this.userCompanies.length <= 1) {
          localStorage.setItem('company', this.userCompanies[0].packetGuid);
          this.$router.push({ name: 'Register' });
        }
        this.$matomo.trackEvent('Authentication', 'Prospect', 'Is Authenticating');
      });
    },
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap');
  .v-input--checkbox .v-label {
    font-size: 0.875rem !important;
    font-weight: 400;
    line-height: 1.25rem;
  }
</style>
